import { render, staticRenderFns } from "./FlowDetail.vue?vue&type=template&id=a94e4f1e&scoped=true&lang=html&"
import script from "./FlowDetail.vue?vue&type=script&lang=js&"
export * from "./FlowDetail.vue?vue&type=script&lang=js&"
import style0 from "./FlowDetail.vue?vue&type=style&index=0&id=a94e4f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94e4f1e",
  null
  
)

component.options.__file = "FlowDetail.vue"
export default component.exports